import React, { useState, FunctionComponent, useEffect } from 'react';
import { Presentation } from './presentation';
import type { SpecialShowProps as Props } from './types';
import { OtherSpecial, SpecialDetail } from '../../../types/specialShow';
import { fetchOtherSpecials, fetchSpecial } from '../../../services/specials';
import { useDevice } from '../../../hooks/device';

export const Component: FunctionComponent<Props> = (props) => {
  const { isPc } = useDevice();
  const [loading, setLoading] = useState(true);
  const [specialDetail, setSpecialDetail] = useState<SpecialDetail | null>(null);
  const [otherSpecials, setOtherSpecials] = useState<OtherSpecial[]>([]);

  useEffect(() => {
    const fetchSpecialDetailData = async () => {
      try {
        setLoading(true);
        const [specialResponse, otherResponse] = await Promise.all([
          fetchSpecial(props.specialId),
          fetchOtherSpecials(props.specialId)
        ]);
        setSpecialDetail(specialResponse);
        setOtherSpecials(otherResponse.otherSpecials);
      } catch (e) {
        console.error('Failed to fetch special detail data:', e);
      } finally {
        setLoading(false);
      }
    };
    fetchSpecialDetailData();
  }, [props.specialId]);

  return (
    <Presentation
      {...props}
      isPc={isPc}
      loading={loading}
      specialDetail={specialDetail}
      otherSpecials={otherSpecials}
    />
  );
};
